import { useCallback, useEffect, useState } from "react"
import { Container, Row, Col, Card, Button, Form, InputGroup, Badge, ListGroup, Spinner, Modal, Table, Tabs, Tab } from "react-bootstrap"
import { useNavigate, useLocation } from 'react-router-dom';
import DashboardView from '../../components/DashboardView';

import { useStateContext } from "../../contexts/ContextProvider";
//import { AttendancesContext } from "../../contexts/AttendancesContext";
import Menu from "../../components/Menu";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faShoppingCart, faSearch, faPlus, faMinus, faPlusCircle, faTimes, faCheck, faFolderOpen, 
  faFilePrescription, faPrescriptionBottleAlt, faCashRegister, faChartColumn, faSpinner
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import api from "../../services/api";
import debounce from '../../utils/debounce';
import searchingImg from '../../assets/img/searching.svg';
import noDataImg from '../../assets/img/no_data.svg';
import logo from '../../assets/img/achemed-simbolo-azul.png';
import Swal from "sweetalert2";
import Globals from "../../Globals";
import openWhatsApp from "../../utils/openWhatsapp";

export default function SalesEdit() {
  const { user } = useStateContext();
  //let { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const customer = location.state?.customer || null;
  const phone = location.state?.phone || null;
  const professional = location.state?.professional || null;
  const dateScheduling = location.state?.dateScheduling || null;
  const shopper = location.state?.shopper || null;
  const scheduling = location.state?.scheduling || null;
  const requisition = location.state?.requisition || null;
  const attendance_id = location.state?.attendance_id || null;

  const [prescriptions, setPrescriptions] = useState([]);
  const [medicines, setMedicines] = useState([]);
  const [loadingPrescriptions, setLoadingPrescriptions] = useState(false);
  const [loading, setLoading] = useState(false);

  const [inputValue, setInputValue] = useState('');
  const [search, setSearch] = useState('');
  const [selectedMedicines, setSelectedMedicines] = useState([]);

  const [seeDashboard, setSeeDashboard] = useState(false);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [newMedicineModalOpen, setNewMedicineModalOpen] = useState(false);
  const [budgetModalOpen, setBudgetModalOpen] = useState(false);

  const [name, setName] = useState("");
  const [presentation, setPresentation] = useState("");
  const [unit, setUnit] = useState("");
  const [posologia, setPosologia] = useState("");
  const [isSpecial, setIsSpecial] = useState(false);

  const [loadingMedicineItems, setLoadingMedicineItems] = useState(false);

  // Dados de exemplo para histórico de orçamentos
  const historicoOrcamentos = [
    {
      id: "orc-001",
      data: "10/05/2023",
      total: 45.2,
      status: "finalizado",
      itens: [
        { medicamento: "Losartana 50mg", quantidade: 2, preco: 15.9 },
        { medicamento: "Atenolol 25mg", quantidade: 1, preco: 12.75 },
      ],
    },
    {
      id: "orc-002",
      data: "08/05/2023",
      total: 28.4,
      status: "cancelado",
      itens: [{ medicamento: "Hidroclorotiazida 25mg", quantidade: 3, preco: 8.5 }],
    },
    {
      id: "orc-003",
      data: "05/05/2023",
      total: 67.85,
      status: "finalizado",
      itens: [
        { medicamento: "Losartana 50mg", quantidade: 1, preco: 18.5 },
        { medicamento: "Atenolol 25mg", quantidade: 2, preco: 10.9 },
        { medicamento: "Hidroclorotiazida 25mg", quantidade: 2, preco: 7.9 },
      ],
    },
    {
      id: "orc-004",
      data: "10/05/2023",
      total: 45.2,
      status: "finalizado",
      itens: [
        { medicamento: "Losartana 50mg", quantidade: 2, preco: 15.9 },
        { medicamento: "Atenolol 25mg", quantidade: 1, preco: 12.75 },
      ],
    },
    {
      id: "orc-005",
      data: "08/05/2023",
      total: 28.4,
      status: "cancelado",
      itens: [{ medicamento: "Hidroclorotiazida 25mg", quantidade: 3, preco: 8.5 }],
    },
    {
      id: "orc-006",
      data: "05/05/2023",
      total: 67.85,
      status: "finalizado",
      itens: [
        { medicamento: "Losartana 50mg", quantidade: 1, preco: 18.5 },
        { medicamento: "Atenolol 25mg", quantidade: 2, preco: 10.9 },
        { medicamento: "Hidroclorotiazida 25mg", quantidade: 2, preco: 7.9 },
      ],
    },
  ]

  useEffect(() => {
    const getPrescriptions = async () => {
      setLoadingPrescriptions(true);

      await api.post('api/attendances/pharmacy/list/document', {
        shopper_id: shopper,
        requisition_id: requisition
      })
        .then(response => {
          setPrescriptions(response.data)
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          setLoadingPrescriptions(false);
        })
    }

    const getMedicineItems = async () => {
      try {
        const response = await api.post('api/payment/prescription/pharmacy/items', {
          attendance_id,
          shopper_id: shopper,
        });

        let medicines = []

        if (Array.isArray(response.data) && response.data.length === 0) {
          medicines = [];
        } else {
          medicines = response.data?.data?.schedulings?.data || [];
        }

        if (medicines.length > 0) {
          setLoadingMedicineItems(true);

          for (const medicine of medicines) {
            try {
              const res = await api.get(`api/pharmacydrugs/${medicine.pharmacy_drug_id}`);
              
              setSelectedMedicines((prev) => [
                ...prev,
                {
                  ...res.data.data,
                  quantity: medicine.pharmacy_drug_quantity,
                  unit_price: medicine.pharmacy_drug_price,
                }
              ])
            } catch (error) {
              console.error(error);
            }

            setLoadingMedicineItems(false);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    getPrescriptions()
    //getMedicineItems();
  }, [])

  const debouncedSearch = useCallback(
    debounce((value) => {
      setSearch(value);
    }, 500),
    []
  );

  const getTabName = (str) => {
    if (str === 'receituário') {
      str += ' Normal';
    }

    //capitalize
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const getPrescriptionIcon = (type) => {
    let icon;

    type === '1' ?
      icon = <FontAwesomeIcon icon={faFilePrescription} size="xl" className="me-4" title="Receituário Normal" />
      :
      icon = <FontAwesomeIcon icon={faPrescriptionBottleAlt} size="xl" className="me-4" title="Receituário Normal" />

    return icon;
  }

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value.toUpperCase());
    debouncedSearch(value.toUpperCase());
  };

  const toggleMedicine = (medicine) => {
    setSelectedMedicines((prev) => {
      const isCurrentlySelected = prev.some(item => item.id === medicine.id);

      if (isCurrentlySelected) {
        return prev.filter(item => item.id !== medicine.id);
      } else {
        return [...prev, { ...medicine, quantity: 1 }];
      }
    });
  };

  const setQuantity = (medicine, delta) => {
    setSelectedMedicines((prev) => {
      return prev.map((item) => {
        if (item.id === medicine.id) {
          const newQuantity = Math.max(1, item.quantity + delta) // Mínimo de 1
          return { ...item, quantity: newQuantity }
        }
        return item
      })
    })
  }

  const isMedicineSelected = (medicine) => {
    return selectedMedicines.some((item) => item.id === medicine.id)
  }

  const getQuantity = (medicine) => {
    const item = selectedMedicines.find((item) => item.id === medicine.id)
    return (item.quantity || 1)
  }

  const formatMoney = (value) => {
    return `R$ ${Number(value).toFixed(2).replace('.', ',')}`;
  }

  const total = selectedMedicines.reduce((acc, selectedItem) => {
    return acc + (selectedItem.price || 0) * selectedItem.quantity
  }, 0)

  // const openHistoryModal = () => {
  //   setHistoryModalOpen(true);
  // }

  const closeHistoryModal = () => {
    setHistoryModalOpen(false);
  }

  const goToDashboard = () => {
    setSeeDashboard(true);
  }

  // const backToPrescription = () => {
  //   setSeeDashboard(false);
  // }

  const openNewMedicineModal = () => {
    setNewMedicineModalOpen(true);
    setName(inputValue.toUpperCase());
  }

  const closeNewMedicineModal = () => {
    setNewMedicineModalOpen(false);

    setName('');
    setUnit('');
    setPosologia('');
    setIsSpecial(false);
  }

  const openBudgetModal = () => {
    setBudgetModalOpen(true);
  }

  const closeBudgetModal = () => {
    setBudgetModalOpen(false);
  }

  const addNewMedicine = async () => {
    setNewMedicineModalOpen(false);

    Swal.fire({
      title: 'Aguarde',
      text: 'Adicionando novo medicamento...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    })

    let form = new FormData();

    form.set('name', name);
    form.set('unit', unit);
    form.set('dosage', posologia);
    form.set('type', isSpecial ? 'Especial' : 'Normal');
    form.set('without_medication', true);

    await api.post('api/pharmacydrugs', form)
      .then((response) => {
        Swal.close();

        Swal.fire({
          title: 'Sucesso',
          text: 'Medicamento adicionado com sucesso!',
          icon: 'success',
          confirmButtonText: 'OK'
        });

        // refaz a busca
        // marca o medicamento como selecionado
        debouncedSearch(name);
        toggleMedicine(response.data.data.id);
      })
      .catch((error) => {
        console.error("Erro ao adicionar medicamento:", error);
        Swal.fire({
          title: 'Erro',
          text: 'Não foi possível adicionar o medicamento. Tente novamente.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      });
  }

  const confirmBudget = async () => {
    setBudgetModalOpen(false);

    let pdfPath;

    Swal.fire({
      title: 'Aguarde...',
      text: 'Confirmando orçamento...',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    await api.post('api/prescription/attendant/items', {
      shopper_id: shopper,
      scheduling_id: scheduling,
      user_id: user.user.id,
      manual_budget: true,
      attendance_id: attendance_id,
      budget_status: '1',
      items: selectedMedicines.map((med) => ({
        ...med,
        pharmacy_drug_id: med.id,
        qnt_stock: med.stock_quantity || '1.000'
      })),
    })
      .then(async (response) => {
        await api.post(`api/attendances/prescriptionitems`, {
          attendance_id
        })
          .then(response => {
            //file path
            pdfPath = Globals.BASE_URL + '/storage/' + response.data.path
          })

        Swal.close();

        Swal.fire({
          icon: 'success',
          title: 'Orçamento confirmado com sucesso!',
          html: 'O orçamento foi processado e um arquivo PDF foi gerado.',
          showConfirmButton: true,
          confirmButtonText: 'Voltar às Vendas',
          confirmButtonColor: '#56CAF0',
        
          showDenyButton: true,
          denyButtonText: 'Abrir PDF',
          denyButtonColor: '#00468B',
        
          showCancelButton: true,
          cancelButtonText: 'Fechar',
          cancelButtonColor: '#6c757d', // cinza padrão
        
          allowOutsideClick: false,
          preDeny: () => {
            window.open(pdfPath, '_blank');
            return false; // impede o swal de fechar
          }
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/sales', { replace: true });
          }
          // se for deny, o preDeny já trata
          // se for cancel, nada acontece (fecha o modal)
        });
        
      })
      .catch(error => {
        console.error(error);
        Swal.close();

        Swal.fire({
          title: 'Erro',
          text: 'Não foi possível confirmar o orçamento. Tente novamente.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      })

  };

  useEffect(() => {
    const searchMedicines = async () => {
      if (search.length !== 0) {
        setLoading(true);

        await api.get(`api/pharmacydrugs/search/${search}`)
          .then((response) => {
            setMedicines(response.data.data)
            //setMedicines(data);
          })
          .catch((error) => {
            console.error("Erro ao buscar medicamentos:", error);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }

    searchMedicines()
  }, [search])

  const screenTela = seeDashboard ? (
    <DashboardView seeDashboard={seeDashboard} onClose={() => setSeeDashboard(false)} />
  ) : (
    prescriptions ?
      <div className="h-100 overflow-auto">
        <Container fluid className="p-4 vh-100 overflow-auto">
          <div className="d-flex align-items-center mb-2">
            <FontAwesomeIcon icon={faCashRegister} size="2x" className="me-4" style={{ color: '#00468B' }} />
            <h1 className="col-6 col-sm-6 col-lg-6 name-screen my-4"><span className="name-screen-title">Orçamento</span> </h1>

            <Button
              variant="outline-success"
              size="sm"
              className="text-success border-success py-2 px-3 d-flex align-items-center"
              title="Contatar cliente por Whatsapp"
              onMouseEnter={(e) => {
                e.target.style.opacity = '.7'
              }}
              onMouseLeave={(e) => {
                e.target.style.opacity = '1';
                e.target.style.backgroundColor = '#DCF8C6';
              }}
              onClick={(e) => openWhatsApp(phone, e)}
            >
              <FontAwesomeIcon icon={faWhatsapp} className="me-2" size="2x" /> Whatsapp
            </Button>

            {/* <Button
              variant="outline-primary"
              className="mx-3"
              onClick={openHistoryModal}
              title="Ver histórico de orçamentos do cliente"
            >
              <FontAwesomeIcon icon={faHistory} className="me-1" size="2x" />
            </Button> */}

            <Button
              variant="outline-primary"
              onClick={goToDashboard}
              title="Ver Dashboard de vendas"
              className="mx-3"
            >
              <FontAwesomeIcon icon={faChartColumn} className="me-1" size="2x" /> Dashboard
            </Button>

          </div>

          <Row className="g-4" style={{ overflowY: 'auto' }}>
            <Col xs={12} xl={6}>
              <Card className="h-100">
                <Card.Header className="bg-white">
                  <div className="d-flex justify-content-between align-items-center">
                    <Card.Title className="mb-0">Informações da Prescrição</Card.Title>
                  </div>
                </Card.Header>
                <Card.Body>
                  <div className="mb-3">
                    <div className="fw-semibold">Paciente: <span className="fw-normal">{customer}</span></div>
                  </div>
                  <div className="mb-3">
                    <div className="fw-semibold">Profissional: <span className="fw-normal">{professional}</span></div>
                  </div>
                  <div className="mb-3">
                    <div className="fw-semibold">Data: <span className="fw-normal">{dateScheduling}</span></div>
                  </div>
                  <div className="mb-3">
                    <div className="fw-semibold">Whatsapp: <span className="fw-normal">{phone}</span></div>
                  </div>

                  <hr />

                  <div>
                    {
                      prescriptions.length > 1 && (
                        <div className="fw-semibold mb-2">
                          Receituários
                        </div>
                      )}

                    {
                      loadingPrescriptions ? (
                        <div className="text-center py-5 d-flex flex-column align-items-center">
                          <Spinner animation="border" role="status" className="mb-3" style={{ color: '#00468B' }}>
                            <span className="visually-hidden">Carregando...</span>
                          </Spinner>
                          <div className="text-muted">Carregando receituários...</div>
                        </div>
                      ) : (

                        <Tabs id="prescription-tabs" fill>
                          {
                            prescriptions.length > 1 && (
                              <Tab
                                eventKey="todos"
                                title={
                                  <span>
                                    <FontAwesomeIcon icon={faFolderOpen} size="xl" className="me-4" title="Todos os receituários do paciente" />
                                    Todos
                                  </span>}
                              >
                                <Card className="mt-3" style={{ height: '300px', overflow: 'auto' }}>
                                  <Card.Body
                                    className="bg-light"
                                    dangerouslySetInnerHTML={{ __html: prescriptions[0].text + '<hr>' + prescriptions[1].text }}
                                  />
                                </Card>

                              </Tab>
                            )
                          }

                          {
                            prescriptions.map((prescription) => {
                              return (
                                <Tab
                                  key={prescription.id}
                                  eventKey={prescription.id}
                                  title={
                                    <span>
                                      {getPrescriptionIcon(prescription.type_doc)}
                                      {getTabName(prescription.doc_name)}
                                    </span>
                                  }
                                >
                                  <Card className="mt-3" style={{ height: '400px', overflow: 'hidden' }}>
                                    {/* <Card.Body
                                      className="bg-light"
                                      dangerouslySetInnerHTML={{ __html: prescription.text }}
                                    /> */}
                                    <iframe
                                      src={`${prescription.access_url}#navpanes=0`}
                                      width="100%"
                                      height="100%"
                                      style={{ border: 'none', minHeight: '500px' }}
                                      title="Visualização do arquivo da prescrição"
                                    />
                                  </Card>

                                </Tab>
                              )
                            })
                          }
                        </Tabs>
                      )}
                  </div>

                </Card.Body>
              </Card>

            </Col>

            <Col xs={12} xl={6} className="mb-5 mb-xl-0">
              <Card className="h-100">
                <Card.Header className="bg-white">
                  <Card.Title className="mb-0">Selecionar Medicamentos</Card.Title>
                </Card.Header>
                <Card.Body>
                  {/* <div className="d-flex"> */}
                  <InputGroup className="mb-3">
                    <InputGroup.Text id="basic-addon1" className="mr-1">
                      <FontAwesomeIcon icon={faSearch} />
                    </InputGroup.Text>

                    <Form.Control
                      type="text"
                      placeholder="Buscar medicamentos..."
                      className="rounded-1"
                      value={inputValue}
                      onChange={handleInputChange}
                    />

                    <Button
                      //variant="primary"
                      className="ms-2 rounded-1 primary-background text-white primary-border"
                      onClick={openNewMedicineModal}
                    >
                      <FontAwesomeIcon
                        icon={faPlusCircle}
                        size="sm"
                        className="me-2"
                      />
                      Novo medicamento
                    </Button>
                  </InputGroup>


                  {/* </div> */}

                  <div className="border rounded" style={{ height: "310px", overflowY: "auto" }}>
                    <ListGroup variant="flush">
                      {search.length === 0 ? (
                        selectedMedicines.length > 0 ? 
                        (
                          selectedMedicines.map((med) => {
                            const isSelected = isMedicineSelected(med);
  
                            return (
                              <ListGroup.Item
                                key={med.id}
                                className={`d-flex align-items-center p-2 rounded transition ${isSelected ? "border primary-border blue-200" : ""
                                  }`}
                              >
                                <Form.Check
                                  type="checkbox"
                                  id={`med-${med.id}`}
                                  checked={isSelected}
                                  onChange={() => toggleMedicine(med)}
                                  className="me-2"
                                />
                                <div className="d-flex justify-content-between w-100">
                                  <label
                                    htmlFor={`med-${med.id}`}
                                    className="d-flex justify-content-between align-items-center cursor-pointer w-100 mb-0"
                                    style={{ fontSize: "0.875rem" }}
                                  >
                                    <div className={`col-5 ${isSelected ? "primary-color" : ""}`}>
                                      <div>
                                        {med.name}
                                        <br />
                                        {med.presentation}
                                        <br />
                                        <div className="primary-color">{med.laboratory}</div>
                                      </div>
                                    </div>
  
                                    {med.without_medication && (
                                      <span className="text-danger">EM FALTA</span>
                                    )}
  
                                    {isSelected && (
                                      <div className="d-flex align-items-center gap-1 ms-2">
                                        <Button
                                          variant="outline-secondary"
                                          size="sm"
                                          className="rounded-circle p-0 d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "1.5rem",
                                            height: "1.5rem",
                                            minWidth: "1.5rem",
                                          }}
                                          onClick={() => setQuantity(med, -1)}
                                        >
                                          <FontAwesomeIcon
                                            icon={faMinus}
                                            style={{ fontSize: "0.75rem" }}
                                          />
                                        </Button>
                                        <span
                                          className="fw-medium text-center"
                                          style={{
                                            minWidth: "1.5rem",
                                            fontSize: "0.875rem",
                                          }}
                                        >
                                          {getQuantity(med)}
                                        </span>
                                        <Button
                                          variant="outline-secondary"
                                          size="sm"
                                          className="rounded-circle p-0 d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "1.5rem",
                                            height: "1.5rem",
                                            minWidth: "1.5rem",
                                          }}
                                          onClick={() => setQuantity(med, 1)}
                                        >
                                          <FontAwesomeIcon
                                            icon={faPlus}
                                            style={{ fontSize: "0.75rem" }}
                                          />
                                        </Button>
                                      </div>
                                    )}
  
                                    {med.price && (
                                      <div className="text-end">
                                        <div className={isSelected ? "primary-color" : ""}>
                                          {formatMoney(med.price)}
                                        </div>
                                      </div>
                                    )}
                                  </label>
                                </div>
                              </ListGroup.Item>
                            );
                          })
                        ) :
                        (
                          <ListGroup.Item className="text-center text-muted py-4 d-flex flex-column align-items-center">
                            <img src={searchingImg} alt="Pesquisa" width={175} className="mb-3" loading="lazy" />
                            Busque os medicamentos no campo acima. <br /> Ou adicione um novo medicamento.
                          </ListGroup.Item>
                        )

                      ) : loading ? (
                        <ListGroup.Item className="text-center py-4 d-flex flex-column align-items-center">
                          <Spinner animation="border" role="status" className="mb-3" style={{ color: '#00468B' }}>
                            <span className="visually-hidden">Carregando...</span>
                          </Spinner>
                          <div className="text-muted">Buscando medicamentos...</div>
                        </ListGroup.Item>
                      ) : medicines.length === 0 ? (
                        <ListGroup.Item className="text-center text-danger py-4 d-flex flex-column align-items-center">
                          <img src={noDataImg} alt="Sem resultados" width={175} className="mb-3" loading="lazy" />
                          Nenhum medicamento encontrado.
                          <Button className="flex items-center mt-2" onClick={openNewMedicineModal}>
                            <FontAwesomeIcon
                              icon={faPlusCircle}
                              size="sm"
                              className="me-2"
                            />
                            Novo Medicamento
                          </Button>
                        </ListGroup.Item>
                      ) : (
                        medicines.map((med) => {
                          const isSelected = isMedicineSelected(med);

                          return (
                            <ListGroup.Item
                              key={med.id}
                              className={`d-flex align-items-center p-2 rounded transition ${isSelected ? "border primary-border blue-200" : ""
                                }`}
                            >
                              <Form.Check
                                type="checkbox"
                                id={`med-${med.id}`}
                                checked={isSelected}
                                onChange={() => toggleMedicine(med)}
                                className="me-2"
                              />
                              <div className="d-flex justify-content-between w-100">
                                <label
                                  htmlFor={`med-${med.id}`}
                                  className="d-flex justify-content-between align-items-center cursor-pointer w-100 mb-0"
                                  style={{ fontSize: "0.875rem" }}
                                >
                                  <div className={`col-5 ${isSelected ? "primary-color" : ""}`}>
                                    <div>
                                      {med.name}
                                      <br />
                                      {med.presentation}
                                      <br />
                                      <strong className="primary-color">{med.laboratory}</strong>
                                    </div>
                                  </div>

                                  {med.without_medication && (
                                    <span className="text-danger">EM FALTA</span>
                                  )}

                                  {isSelected && (
                                    <div className="d-flex align-items-center gap-1 ms-2">
                                      <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        className="rounded-circle p-0 d-flex align-items-center justify-content-center"
                                        style={{
                                          width: "1.5rem",
                                          height: "1.5rem",
                                          minWidth: "1.5rem",
                                        }}
                                        onClick={() => setQuantity(med, -1)}
                                      >
                                        <FontAwesomeIcon
                                          icon={faMinus}
                                          style={{ fontSize: "0.75rem" }}
                                        />
                                      </Button>
                                      <span
                                        className="fw-medium text-center"
                                        style={{
                                          minWidth: "1.5rem",
                                          fontSize: "0.875rem",
                                        }}
                                      >
                                        {getQuantity(med)}
                                      </span>
                                      <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        className="rounded-circle p-0 d-flex align-items-center justify-content-center"
                                        style={{
                                          width: "1.5rem",
                                          height: "1.5rem",
                                          minWidth: "1.5rem",
                                        }}
                                        onClick={() => setQuantity(med, 1)}
                                      >
                                        <FontAwesomeIcon
                                          icon={faPlus}
                                          style={{ fontSize: "0.75rem" }}
                                        />
                                      </Button>
                                    </div>
                                  )}

                                  {med.price && (
                                    <div className="text-end">
                                      <div className={isSelected ? "primary-color" : ""}>
                                        {formatMoney(med.price)}
                                      </div>
                                    </div>
                                  )}
                                </label>
                              </div>
                            </ListGroup.Item>
                          );
                        })
                      )}
                    </ListGroup>
                  </div>


                  <hr />

                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="fw-semibold">Itens Selecionados</div>
                    <div className="fs-4">{selectedMedicines.length}</div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="fw-semibold">Total</div>
                    <div className="fs-4 fw-bold">{formatMoney(total)}</div>
                  </div>

                  <div className="w-100 text-center">
                    {
                      loadingMedicineItems ? (
                        <Button variant="success" className="w-50" disabled={selectedMedicines.length === 0} onClick={openBudgetModal}>
                          <FontAwesomeIcon icon={faSpinner} size="lg" className="me-3" />
                          Carregando ...
                        </Button>
                      ) : (
                      <Button variant="success" className="w-50" disabled={selectedMedicines.length === 0} onClick={openBudgetModal}>
                        <FontAwesomeIcon icon={faShoppingCart} size="lg" className="me-3" />
                        Fechar Orçamento
                      </Button>
                      )
                    }
                  </div>

                </Card.Body>
              </Card>

            </Col>
          </Row>

          <Modal show={historyModalOpen} onHide={closeHistoryModal} size="xl" scrollable>
            <Modal.Header closeButton>
              <Modal.Title>Histórico de Orçamentos - {customer}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto' }}>
              <div className="d-flex flex-column gap-3">
                {historicoOrcamentos.map((orcamento) => (
                  <Card key={orcamento.id}>
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div>
                          <div className="fw-semibold">Orçamento #{orcamento.id}</div>
                          <div className="text-muted small">Data: {orcamento.data}</div>
                        </div>
                        <div className="text-end">
                          <div className="fw-bold">R$ {orcamento.total.toFixed(2)}</div>
                          <Badge
                            bg={orcamento.status === "finalizado" ? "primary" : "danger"}
                            className="mt-1"
                          >
                            {orcamento.status === "finalizado" ? "Finalizado" : "Cancelado"}
                          </Badge>
                        </div>
                      </div>
                      <hr className="my-2" />
                      <div className="d-flex flex-column gap-1">
                        {orcamento.itens.map((item, index) => (
                          <div key={index} className="d-flex justify-content-between small">
                            <span>
                              {item.medicamento} (x{item.quantidade})
                            </span>
                            <span>R$ {(item.preco * item.quantidade).toFixed(2)}</span>
                          </div>
                        ))}
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </Modal.Body>
          </Modal>

          <Modal show={newMedicineModalOpen} onHide={closeNewMedicineModal}>
            <Modal.Header closeButton>
              <Modal.Title>Novo Medicamento</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Form className="text-center">
                <Form.Group className="mb-3">
                  <Form.Label>Nome do Medicamento</Form.Label>
                  <Form.Control value={name} type="text" name="name" placeholder="Nome" onChange={value => setName(value.target.value.toUpperCase())} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Apresentação</Form.Label>
                  <Form.Control value={presentation} type="text" name="presentation" placeholder="Apresentação" onChange={value => setPresentation(value.target.value.toUpperCase())} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Unidade</Form.Label>
                  <select className="form-select" onChange={value => setUnit(value.target.value)} defaultValue={'DEFAULT'}>
                    <option value="DEFAULT" disabled hidden>Selecione a Unidade</option>
                    <option value="AdT">ADESIVO TRANSDÉRMICO</option>
                    <option value="Amp">AMPOLA</option>
                    <option value="Bg">BISNAGA</option>
                    <option value="Bl">BLISTER</option>
                    <option value="Cp">COMPRIMIDO</option>
                    <option value="Cj">CONJUNTO</option>
                    <option value="Ct">CARTELA</option>
                    <option value="Cx">CAIXA</option>
                    <option value="Cap">CÁPSULA</option>
                    <option value="Crt">CERATO (g)</option>
                    <option value="Crm">CREME (g)</option>
                    <option value="Drg">DRÁGEA</option>
                    <option value="Elx">ELIXIR (ml)</option>
                    <option value="Env">ENVELOPE</option>
                    <option value="Fl">FLACONETE</option>
                    <option value="Frs">FRASCO</option>
                    <option value="g">GRAMA (g)</option>
                    <option value="Gel">GEL (g)</option>
                    <option value="Kt">KIT</option>
                    <option value="Lt">LATA</option>
                    <option value="Lo">LOÇÃO (g)</option>
                    <option value="mg">MILIGRAMA (mg)</option>
                    <option value="ml">MILILITRO (ml)</option>
                    <option value="Pst">PASTILHA</option>
                    <option value="Pct">PACOTE</option>
                    <option value="Pmd">POMADA (g)</option>
                    <option value="Pt">POTE</option>
                    <option value="Sch">SACHÊ</option>
                    <option value="Sup">SUPOSITÓRIO</option>
                    <option value="Tb">TUBO</option>
                    <option value="Und">UNIDADE</option>
                    <option value="Ugn">UNGÜENTO (g)</option>
                    <option value="Ovu">ÓVULO</option>
                    <option value="Vd">VIDRO</option>
                    <option value="Xp">XAROPE (ml)</option>
                  </select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Posologia</Form.Label>
                  <textarea style={{ height: '15vh' }} className="form-control" value={posologia} type="text" name="posologia" placeholder="Posologia" onChange={value => setPosologia(value.target.value.toUpperCase())}></textarea>
                </Form.Group>
                <Form.Group className="mb-3 text-center">
                  <Form.Label>Tipo de Medicamento</Form.Label>
                  <div>
                    <div className="form-check form-check-inline">
                      <input onChange={() => {
                        setIsSpecial(!isSpecial)
                      }} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" checked={!isSpecial} />
                      <label className="form-check-label" htmlFor="inlineRadio2">Normal</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input onChange={() => {
                        setIsSpecial(!isSpecial)
                      }} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" checked={isSpecial} />
                      <label className="form-check-label" htmlFor="inlineRadio1">Especial</label>
                    </div>

                  </div>

                </Form.Group>
              </Form>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={closeNewMedicineModal}>
                Cancelar
              </Button>
              <Button variant="primary" onClick={addNewMedicine} disabled={!name || !unit || !posologia}>
                Salvar Medicamento
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal show={budgetModalOpen} onHide={closeBudgetModal} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Confirmar Orçamento</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="mb-3">
                <p className="text-muted mb-3">Verifique os medicamentos selecionados antes de confirmar:</p>
              </div>

              <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                <Table striped bordered hover responsive>
                  <thead className="table-light">
                    <tr>
                      <th>Medicamento</th>
                      <th className="text-center">Quantidade</th>
                      <th className="text-end">Preço Unitário</th>
                      <th className="text-end">Subtotal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedMedicines.map((medicine) => {
                      const subtotal = (medicine.price || 0) * medicine.quantity;

                      return (
                        <tr key={medicine.id}>
                          <td>
                            <div>
                              <span>{medicine.name}</span>
                              <br />
                              {medicine.presentation && (
                                <span className="text-muted small">{medicine.presentation}</span>
                              )}
                              {medicine.without_medication && (
                                <Badge bg="warning" text="dark" className="ms-2 mt-1">EM FALTA</Badge>
                              )}
                            </div>
                          </td>
                          <td className="text-center">{medicine.quantity}</td>
                          <td className="text-end">
                            {medicine.price ? formatMoney(medicine.price) : 'N/A'}
                          </td>
                          <td className="text-end">
                            <strong>{formatMoney(subtotal)}</strong>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  {/* <tfoot className="table-light">
                <tr>
                  <th colSpan="2" className="text-end">Total Geral:</th>
                  <th colSpan="2" className="text-end">
                    <span className="fs-5 text-success">R$ {total.toFixed(2)}</span>
                  </th>
                </tr>
              </tfoot> */}
                </Table>
              </div>

              <div className="mt-3 p-3 bg-light rounded">
                <div className="row justify-content-end">
                  <div className="col-md-3 fs-5">
                    <strong>Total:</strong> <span className="text-success">{formatMoney(total)}</span>
                  </div>
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={closeBudgetModal}>
                <FontAwesomeIcon icon={faTimes} className="me-2" />
                Cancelar
              </Button>
              <Button variant="success" onClick={confirmBudget}>
                <FontAwesomeIcon icon={faCheck} className="me-2" />
                Confirmar Orçamento
              </Button>
            </Modal.Footer>
          </Modal>

        </Container >
      </div>
      :
      <div className='d-flex justify-content-center align-items-center gap-3' style={{ flexDirection: 'column', marginTop: '20vh' }}>
        <img src={logo} width={50} alt="Achemed" />
        <h2>Dados não encontrados</h2>
        <Button onClick={() => navigate('/sales')}>Voltar para a página de vendas</Button>
      </div>
  )
  return (
    <Menu screen={screenTela} />
  )
}